<template>
	<div>
		<ModalBox
			v-model="legacyModalVisible"
			:size="modalSize"
			hide-close
			header-class="!hidden"
			wrapper-classes="lg:h-auto lg:max-h-none"
			:close-on-backdrop="false"
		>
			<div class="px-6 pt-6 text-surface-text-2">{{ message }}{{ streamCat }}</div>
			<div v-if="body" class="px-6 pt-2 text-surface-7 text-sm">{{ body }}</div>
			<slot />

			<template #footer>
				<div class="flex justify-end gap-2 p-6">
					<FormButton type="secondary" size="md" @click="dismiss">
						{{ cancelText }}
					</FormButton>
					<!-- Same entry point as VOD "New Video" / pre-recorded upload: opens GlobalUppyUploader -->
					<FormButton type="main" size="md" @click="onConfirmUpload">
						<icon-base class="mr-2 shrink-0" fill="none">
							<icon-file-new />
						</icon-base>
						{{ okText }}
					</FormButton>
				</div>
			</template>
		</ModalBox>
	</div>
</template>

<script>
import ModalBox from '@/components/modals/ModalBox.vue'
import { legacyModalBridgeMixin } from '@/composables/useLegacyModalBridge'
import FormButton from '@/components/Atoms/FormButton.vue'
import IconBase from '@/components/icon/IconBase.vue'
import IconFileNew from '@/components/icon/IconFileNew.vue'

export default {
	name: 'ReplaceVodModal',
	mixins: [legacyModalBridgeMixin],
	components: {
		ModalBox,
		FormButton,
		IconBase,
		IconFileNew,
	},
	props: {
		modalId: {
			type: String,
			default: 'modal-confirm',
		},
		modalSize: {
			type: String,
			default: 'sm',
			validator(v) {
				return ['xl', 'lg', 'md', 'sm'].some((size) => size === v)
			},
		},
		modalType: {
			type: String,
			default: 'primary',
		},
		message: {
			type: String,
			required: false,
		},
		body: {
			type: String,
			required: false,
		},
		streamCat: {
			type: String,
		},
		okText: {
			type: String,
			default: 'Yes',
		},
		cancelText: {
			type: String,
			default: 'No',
		},
		showConfirm: {
			type: Boolean,
			default: true,
			required: false,
		},
		closeoutsideClick: {
			type: Boolean,
			default: false,
		},
		confirmCancelEvent: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			processing: false,
		}
	},
	methods: {
		onConfirmUpload() {
			this.$emit('modal-confirm')
			this.hideLegacyModal()
		},
		dismiss(cancel = true) {
			if (cancel) {
				this.$emit('modal-cancel')
			}
			this.hideLegacyModal()
			this.$emit('modal-dismiss')
			setTimeout(() => {
				this.processing = false
			}, 1000)
		},
	},
}
</script>

<style scoped></style>
